export default __webpack_public_path__ + "static/media/leftArrow.43ef89f5.svg";